<template>
  <el-dialog
    class="rc-dialog"
    :title="titleName"
    :visible.sync="dialogVisible"
    width="700px"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    @close="clearDept"
  >
    <el-transfer
      filterable
      :filter-method="filterMethod"
      filter-placeholder="请输入组织名称"
      v-model="value"
      :data="data"
      :props="transferProps"
      :titles="['组织名称', '已选组织']"
    >
    </el-transfer>
    <span slot="footer" class="dialog-footer">
      <el-checkbox
        v-permission="'audioSet:share:online'"
        class="m-l-15"
        v-model="needOnline"
        key="needOnline"
        :true-label="1"
        :false-label="0"
        >共享后直接上线
      </el-checkbox>
      <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" size="small" @click="share">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Bus from "../Bus";
import { shareDeptList } from "@/api/dept";
import { shareAllAudioSet, shareAudioSet } from "@/api/audioSet";
export default {
  data() {
    return {
      dialogVisible: false,
      data: [],
      value: [],
      audioSetIds: [],
      titleName: "",
      needOnline: 0,
      transferProps: {
        key: 'uuid',
        label: 'deptName'
      },
      filterMethod(query, item) {
        return item.deptName.indexOf(query) > -1;
      }
    };
  },
  created() {
    Bus.$on("oneClickShare", ids => {
      this.dialogVisible = true;
      this.audioSetIds = ids;
      if (ids.length === 0) {
        this.titleName = "一键共享";
      } else {
        this.titleName = "共享";
      }
    });
    shareDeptList().then(res => {
      if (!res || res.code != 0) return;
      this.data = res.data;
    });
  },
  updated() {
    let doms = document.getElementsByClassName("el-checkbox__label");
    for (let i = 0; i < doms.length; i++) {
      const dom = doms[i];
      dom.title = dom.innerText;
    }
  },
  methods: {
    share() {
      if (this.value.length === 0) {
        this.$message({
          message: "请选择要共享的学院",
          type: "warning"
        });
      } else {
        if (this.audioSetIds.length === 0) {
          shareAllAudioSet({
            uuids: [],
            deptIds: this.value,
            needOnline: this.needOnline,
          }).then(res => {
            if (!res || res.code != 0) return;
            this.$message({
              message: "音频集共享成功",
              type: "success"
            });
            this.dialogVisible = false;
            Bus.$emit("reload");
          });
        } else {
          shareAudioSet({
            uuids: this.audioSetIds,
            deptIds: this.value,
            needOnline: this.needOnline,
          }).then(res => {
            if (!res || res.code != 0) return;
            this.$message({
              message: "音频集共享成功",
              type: "success"
            });
            this.dialogVisible = false;
            Bus.$emit("reload");
          });
        }
      }
    },
    clearDept() {
      this.value = [];
    }
  },
  beforeDestroy() {
    Bus.$off("oneClickShare");
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    max-height: 330px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
